/* eslint-disable */
import axios from "axios";
import moment from "moment";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";

export default {
    name: "SdvPlanModal",
    components: { customModal },

    props: {
        editingId: {
            type: String,
            default: null
        }
    },

    emits: ["closeModal", "saved"],

    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            token: "",
            studyId: "",
            studyRef: "",
            studyVersionList: [],     
            hasActivePlan: false,
            plan: {
                planName: "",
                effectiveFrom: "",
                description: "",
                changeReason: "",
                planVersion: null,
                studyVersion: ""       
            },
            isEditMode: false,
            loading: false,
            errors: {
                planName: false,
                effectiveFrom: false,
                studyVersion: false,   
                changeReason: false
            },
            errorMessages: {
                planName: "",
                effectiveFrom: "",
                studyVersion: "",      
                changeReason: ""
            },
        };
    },

    computed: {
        minEffectiveDate() {
            return moment().format("YYYY-MM-DD");
        },
    },

    async mounted() {
        this.token = store.getters.getIdToken;
        this.studyId = store.getters.getStudyIs;
        await this.getstudyversion();

        if (this.editingId) {
            this.isEditMode = true;
            await this.fetchPlanById();
        } else {
            await this.checkActivePlan();
        }
    },

    methods: {

        clearError(field) {
            this.errors[field] = false;
            this.errorMessages[field] = "";
        },

        validate() {
            this.clearErrors();
            let isValid = true;

            if (!this.plan.planName || !this.plan.planName.trim()) {
                this.errors.planName = true;
                this.errorMessages.planName = "Please enter plan name";
                isValid = false;
            } else if (this.plan.planName.length > 100) {
                this.errors.planName = true;
                this.errorMessages.planName = "Plan name cannot exceed 100 characters";
                isValid = false;
            }

            if (!this.plan.studyVersion) {
                this.errors.studyVersion = true;
                this.errorMessages.studyVersion = "Please select study version";
                isValid = false;
            }

            if (!this.plan.effectiveFrom) {
                this.errors.effectiveFrom = true;
                this.errorMessages.effectiveFrom = "Please select effective from date";
                isValid = false;
            } else if (moment(this.plan.effectiveFrom).isBefore(moment(), "day")) {
                this.errors.effectiveFrom = true;
                this.errorMessages.effectiveFrom = "Effective From cannot be in the past";
                isValid = false;
            }

            if (this.hasActivePlan && (!this.plan.changeReason || !this.plan.changeReason.trim())) {
                this.errors.changeReason = true;
                this.errorMessages.changeReason = "Change reason is required when amending an active plan";
                isValid = false;
            }

            return isValid;
        },

        clearErrors() {
            this.errors.planName = false;
            this.errors.effectiveFrom = false;
            this.errors.studyVersion = false; 
            this.errors.changeReason = false;
            this.errorMessages.planName = "";
            this.errorMessages.effectiveFrom = "";
            this.errorMessages.studyVersion = ""; 
            this.errorMessages.changeReason = "";
        },

        async getstudyversion() {
            try {
                const currentstudy = store.getters.getStudyIs;
                const response = await axios.get(
                    `${this.baseurl}/management/study/studyversions`,
                    {
                        params: { studyId: currentstudy },
                        headers: {
                            Authorization: "Bearer " + this.token,
                            "Content-Type": "application/json"
                        }
                    }
                );

                this.studyVersionList = response.data || [];

                if (!this.isEditMode) {
                    const latestVersion = localStorage.getItem("selectedsetlatestversion");
                    const matchExists = latestVersion &&
                        this.studyVersionList.some(v => v.version === latestVersion);

                    if (matchExists) {
                        this.plan.studyVersion = latestVersion;
                    } else if (this.studyVersionList.length === 1) {
                        this.plan.studyVersion = this.studyVersionList[0].version;
                    }
                }
            } catch (error) {
                console.error("Error fetching studyversion:", error);
                this.studyVersionList = [];
            }
        },

        async checkActivePlan() {
            try {
                const response = await axios.get(
                    `${this.baseurl}/management/sdv/getsdvplans`,
                    {
                        params: {
                            studyId: this.studyId,
                            status: "Active",
                            PageNumber: 1,
                            PageSize: 1
                        },
                        headers: {
                            Authorization: "Bearer " + this.token,
                            "Content-Type": "application/json"
                        }
                    }
                );
                this.hasActivePlan = (response.data.totalCount || 0) > 0;
            } catch (error) {
                console.error("Error checking for active SDV plan:", error);
                this.hasActivePlan = false;
            }
        },

        async fetchPlanById() {
            try {
                this.loading = true;
                const response = await axios.get(
                    `${this.baseurl}/management/sdv/getbyidsdvplan?id=${this.editingId}`,
                    {
                        headers: { Authorization: "Bearer " + this.token }
                    }
                );
                const data = response.data;

                this.plan = {
                    planName: data.planName || "",
                    effectiveFrom: data.effectiveFrom ? moment(data.effectiveFrom).format("YYYY-MM-DD") : "",
                    description: data.description || "",
                    changeReason: data.changeReason || "",
                    planVersion: data.planVersion || null,
                    studyVersion: data.studyVersion || ""   
                };
            } catch (err) {
                console.error(err);
                alert("Failed to load SDV plan data");
            } finally {
                this.loading = false;
            }
        },

        async submitPlan() {
            if (!this.validate()) return;

            this.loading = true;
            try {
                if (this.isEditMode) {
                    const payload = {
                        studyId: this.studyId,
                        planName: this.plan.planName,
                        effectiveFrom: this.plan.effectiveFrom,
                        description: this.plan.description,
                        changeReason: this.plan.changeReason,
                        studyVersion: this.plan.studyVersion   
                    };

                    await axios.put(
                        `${this.baseurl}/management/sdv/updatesdvplan?id=${this.editingId}`,
                        payload,
                        { headers: { Authorization: "Bearer " + this.token } }
                    );

                    alert("SDV Plan updated successfully");

                } else {
                    const payload = {
                        studyId: this.studyId,
                        studyRef: this.studyRef,
                        studyVersion: this.plan.studyVersion,   
                        status: "Draft",
                        planName: this.plan.planName,
                        effectiveFrom: this.plan.effectiveFrom,
                        description: this.plan.description,
                        changeReason: this.plan.changeReason
                    };

                    await axios.post(
                        `${this.baseurl}/management/sdv/createsdvplans`,
                        payload,
                        { headers: { Authorization: "Bearer " + this.token } }
                    );

                    alert("SDV Plan saved as draft");
                }

                this.$emit("saved");
                this.closeModal();

            } catch (err) {
                console.error(err);
                alert(err.response?.data?.detail || "Save failed");
            } finally {
                this.loading = false;
            }
        },

        closeModal() {
            this.$emit("closeModal");
        }
    }
};